/**
 * Screenshot.ts
 *
 * A module for screenshot. It uses the html2canvas package.
 */

const html2canvas: any = require("@1js/html2canvas-trustedtypes");

/**
 * Get screenshot
 * @param domElement document element or document body 
 * @param options background color
 */
export function createScreenshot(domElement?: object, options?: any): Promise<HTMLCanvasElement> {
	return html2canvas(domElement || document.body, { background: "#ffffff", ...options });
}
